import React from 'react'
import './style.css'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'

const PlanUpgradeBanner: React.FC = () => {
  const apps = useSelector((state: any) => state.apps)
  const history = useHistory()

  const handleRedirect = () => {
    history.push(`/app/${apps.active.id}/plans-billing`)
  }

  return (
    <div className="header-upgrade-banner">
      <div className="header-banner__text">
        Free tier is for development only. Upgrade to a paid plan to use in production.
      </div>
      <div className="header-banner__button-container">
        <button type="button" className="header-banner__upgrade-button" onClick={handleRedirect}>
          Upgrade Now
        </button>
      </div>
    </div>
  )
}

export default PlanUpgradeBanner
